import React from 'react';
// import { ICompanyEnv } from './types';

// const config: ICompanyEnv = {
const config = {
    _company: 'faceid',
    baseName: 'FaceID',
    footer: <React.Fragment>
        <p style={{ color: '#999', width: '100%' }}>© 2012-{(new Date()).getFullYear()} 北京旷视科技有限公司 版权所有 | <a style={{ color: 'inherit' }} target="_blank" href="https://beian.miit.gov.cn">京ICP备12036813 号-11</a></p>
        <a style={{ color: '#939393' }} rel="noopener noreferrer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025957">
            <img src={require('image/record.png')} />&nbsp;
            <span>京公网安备 11010802025957号</span>
        </a>
    </React.Fragment>,
    logoImg: <img src={require('image/megvii-logo.png')} alt="" />, // NotFound 页面
    logoLink: <a href="https://en.megvii.com" target="_block" className="logo">
        <img style={{ marginTop: 17 }} src={require('image/megvii-logo.png')} />
    </a>,
    showNavMenu: true,
    languageLink: 'https://faceid.com/',
    showConcatUs: true,
};
export default Object.freeze(config);


// WEBPACK FOOTER //
// ./src/envcompany/envfaceid.jsx